import EditStaffInteractor from "@/usecases/interactors/edit-staff-interactor";
import EditStaffRequest from "@/usecases/requests/edit-staff-request";
import EditStaffResponse from "@/usecases/responses/edit-staff-response";
import StaffGateway from "@/usecases/gateways/staff-gateway";
import ServiceUserGateway from "@/usecases/gateways/service-user-gateway";
import ServiceUser from "@/entities/service-user";
import Role from "@/entities/role";

/**
 * 編集画面の元データを得る
 */
export default class EditStaffQuery implements EditStaffInteractor {
  public constructor(
    private sApi: StaffGateway,
    private uApi: ServiceUserGateway
  ) {}

  public async handle(req: EditStaffRequest): Promise<EditStaffResponse> {
    const s = await this.sApi.get(Number(req.id));
    if (!s) return new EditStaffResponse();
    const users = await this.uApi.getAll();
    const role = getRole(users, s.id);
    const res = { ...new EditStaffResponse(), ...s };
    if (role) {
      res.hasRole = true;
      res.roleId = role.id;
    }
    return res;
  }
}

function getRole(serviceUsers: ServiceUser[], id: number): Role | undefined {
  const user = serviceUsers.find(su => su.staffId === id);
  if (!user || !user.role) return;
  // TODO ここServiceUserApiでやるべきか
  return { ...user.role, id: user.role.id || 0 };
}
